export const censorWord = (txt) => txt[0] + "*".repeat(txt.length - 2) + txt.slice(-1);

export const censorMail = (mail) => {
  const arr = mail.split('@')
  return `${censorWord(arr[0])}@${censorWord(arr[1])}`
}